export const RegexConstants = {
  selectFirsUppercaseLetter: /([A-Z])/g,
  emailRegEx: /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/,
  passRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
};
